import React from "react";

// MUI
import Button from "@mui/material/Button";

// Styles
import styles from "./index.module.scss";

// Hooks
import useTailwindDarkMode from "../../../../utils/hooks/darkMode";

// Types
interface MultipleChoiceAnswersProps {
  answers: any[];
  selectedAnswers: any[];
  onSelectAnswer: (answer: any, index: number) => void;
  fromLevel: boolean
}

const MultipleChoiceAnswers: React.FC<MultipleChoiceAnswersProps> = ({ answers, selectedAnswers, onSelectAnswer, fromLevel }) => {
  const isDark = useTailwindDarkMode();

  const hasAllSelectedAnswers = selectedAnswers?.length == answers.filter(ans => ans.is_correct).length;

  return (
    <div className={`${styles.container} ${fromLevel ? 'flex-col' : 'flex-row flex-wrap'}`}>
      {answers.map((answer, index) => {
        const text = answer.answer;
        const isSelected = selectedAnswers?.includes(answer.id);
        const isCorrect = answer.is_correct;

        let style = styles.answerButton + ` ${fromLevel ? 'w-full' : 'basis-[48%]'}`;
        if (isSelected && isCorrect) style += ` ${styles.correct}`;
        if (isSelected && !isCorrect) style += ` ${styles.incorrect}`;

        return (
          <Button
            key={index}
            variant="outlined"
            classes={{
              root: style,
              disabled: styles.answerButton_disabled,
            }}
            color='secondary'
            onClick={() => onSelectAnswer(answer, index)}
            disabled={hasAllSelectedAnswers}
          >
            {text}
          </Button>
        )
      })}
    </div>
  )
}

export default MultipleChoiceAnswers;
